import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// https://github.com/dcastil/tailwind-merge/blob/v2.3.0/docs/configuration.md
const tailwindMergeConfig = {
  prefix: 'tw-',
  extend: {
    classGroups: {
      'font-size': [{ text: ['xxs'] }],
      'line-height': [{ leading: ['4.5', '7.5', '12'] }],
      'border-radius': ['rounded', 'rounded-lg', 'rounded-full'],
    },
  },
}

const twMerge = extendTailwindMerge(tailwindMergeConfig)

export function mergeClassNames(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
